// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__37487","header":"MessagesList_header__114aU","chat":"MessagesList_chat__2CC_S"};